// extracted by mini-css-extract-plugin
module.exports = {"syncButton":"style__syncButton___3D3OC"};